import type { CSSProperties } from 'react';

export const CATEGORY_BANNER_CTA_TYPES = [
  'NONE',
  'FEATURE',
  'SLOT',
  'OFFER',
  'GIFT',
  'MESSAGE',
  'CROWN_JACKPOT',
] as const;

export type CategoryBannerCtaType = (typeof CATEGORY_BANNER_CTA_TYPES)[number];

export interface CategoryBannerActionButtonElement {
  type: 'ACTION_BTN';
  left: number;
  top: number;
  width: number;
  height: number;
  text: string;
  btnType: string;
  style: {
    fontSize: number;
    color: string;
    display: CSSProperties['display'];
    background: string;
    filter?: string;
  };
}

export interface CategoryBannerLayout {
  elements: { ACTION_BTN?: CategoryBannerActionButtonElement } & Record<string, unknown>;
  attributes: { imageWidth: number; imageHeight: number };
}

export interface CategoryBanner {
  id: string;
  position: number;
  ctaType: CategoryBannerCtaType;
  ctaValue: string | null;
  slotCoinType: 'GC' | 'SC' | null;
  offerPricing: { gcCoin: number; scCoin: number; price: number } | null;
  // Every offer package in order; older backends omit it.
  offerPackages?: { gcCoin: number; scCoin: number; price: number }[];
  imageUrl: string;
  riveFileUrl: string | null;
  riveTextValues: Record<string, string> | null;
  layout: CategoryBannerLayout | null;
}
